import React from "react";
import { getBadgeConfig, showHighestBadgePerLevel } from "./BadgeConfig.js";
import { StackedBadge } from "./BadgeLevels.jsx";
import { $t } from "~/i18n.js";

/**
 * Compact list of badges earned on a specific flight.
 *
 * Props:
 *   badges  {Array}   Badge objects from the flight details API
 *                     { id, name, level, user_id, date_achieved }
 *   flight  {object}  Flight object with gezagvoerder_id/naam and
 *                     tweede_inzittende_id/naam
 */
export const BadgeList = ({ badges, flight }) => {
  if (!badges?.length) return null;

  const BADGE_CONFIG = getBadgeConfig();

  badges = showHighestBadgePerLevel(badges);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 6,
        marginTop: 12,
      }}
    >
      <p className="gray label">{$t("Badges")}</p>

      {badges.map((badge) => {
        const config = BADGE_CONFIG[badge.name];
        if (!config) return null;

        const pilotName =
          badge.user_id === flight.tweede_inzittende_id
            ? flight.tweede_inzittende_naam
            : badge.user_id === flight.gezagvoerder_id
              ? flight.gezagvoerder_naam
              : "";

        return (
          <div
            key={badge.id}
            style={{ display: "flex", alignItems: "center", gap: 10 }}
          >
            <StackedBadge
              icon={config.icon}
              label={config.label}
              count={badge.level}
              earned
              size={24}
              step={4}
            />
            <div>
              <span style={{ fontWeight: 500, fontSize: 13 }}>{pilotName}</span>
              <span style={{ color: "#888", marginLeft: 6, fontSize: 13 }}>
                {config.label}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
